import { Box } from "@mui/system";
import { ReactComponent as BMWKLogo } from "components/icons/iconsSvg/BMWK_Logo.svg";
import { useNavigate } from "react-router-dom";
import translations from "translations";
import { FooterDocumentsContent, FooterDocumentsContentType } from "./FooterDocumentsContent";
import FooterHeader from "./FooterHeader";
import { FooterInfoBoxContent, FooterInfoBoxContentProps } from "./FooterInfoBoxContent";
import {
  StyledFooterContainer,
  StyledFooterDocumentsContainer,
  StyledFooterInfoBoxContainer,
  StyledFooterRoot,
} from "./styles";

const getFoundedByContent = (): FooterInfoBoxContentProps => [
  {
    headerTitle: (
      <Box>
        <Box>{translations.globals.footer.fundedBy}</Box>
        <Box
          style={{ width: "100%", maxWidth: translations.getLanguage() === "en" ? "245px" : "324px" }}
          dangerouslySetInnerHTML={{ __html: translations.globals.footer.officiallyAppointed }}
        />
      </Box>
    ),

    content: [
      {
        icon: (
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <BMWKLogo />
          </Box>
        ),
      },
    ],
  },
];

const getDocumentsContent = ({
  handleImprint,
  handleFaq,
  handlePrivacyPolicy,
  handleEula,
}: {
  handleImprint?: React.MouseEventHandler<HTMLAnchorElement>;
  handleFaq?: React.MouseEventHandler<HTMLAnchorElement>;
  handlePrivacyPolicy?: React.MouseEventHandler<HTMLAnchorElement>;
  handleEula?: React.MouseEventHandler<HTMLAnchorElement>;
}): FooterDocumentsContentType[] => {
  return [
    { label: translations.globals.footer.imprint, onClick: handleImprint ?? (() => null), type: "link" },
    { label: translations.globals.footer.faq, onClick: handleFaq ?? (() => null), type: "link" },
    {
      label: translations.globals.footer.privacyPolicy,
      onClick: handlePrivacyPolicy ?? (() => null),
      type: "link",
    },
    {
      label: translations.globals.footer.eula,
      type: "link",
      onClick: handleEula ?? (() => null),
    },
    {
      label: translations.globals.footer.contact,
      type: "mailto",
      data: {
        email: "info@zerez.net",
      },
    },
  ];
};

interface FooterProps {
  isStartPageOrUnitsOverviewPage: boolean;
}

const Footer = ({ isStartPageOrUnitsOverviewPage }: FooterProps) => {
  const navigate = useNavigate();
  const handleFaq = () => navigate("/faq");
  const handleImprint = () => navigate("/imprint");
  const handlePrivacyPolicy = () => navigate("/privacypolicy");
  const handleEula = () => navigate("/eula");

  const FooterMiddlePart = () => {
    return (
      <>
        <StyledFooterContainer>
          <FooterHeader />
          <StyledFooterInfoBoxContainer>
            <FooterDocumentsContent
              content={getDocumentsContent({ handleFaq, handleImprint, handlePrivacyPolicy, handleEula })}
            />
          </StyledFooterInfoBoxContainer>
        </StyledFooterContainer>
      </>
    );
  };

  return (
    <StyledFooterRoot isStartPageOrUnitsOverviewPage={isStartPageOrUnitsOverviewPage}>
      <StyledFooterContainer>
        <StyledFooterDocumentsContainer>
          <FooterInfoBoxContent content={getFoundedByContent()} FooterMiddlePart={<FooterMiddlePart />} />
        </StyledFooterDocumentsContainer>
      </StyledFooterContainer>
    </StyledFooterRoot>
  );
};

export default Footer;
